//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';
import { useNavigate } from "react-router-dom";

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
} from '@mui/material';

// === COMPONENTS ===

//#endregion

//-----------------------------------------------------------------
export function FilesHeader() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme    = useTheme();
  const navigate = useNavigate();

  const _styles = {
    container: {
      display: 'flex',
      padding : '0.5rem' ,
      width   : '100%' ,
    },
    button_rules: {

    }
  }

  const BUTTON_RULES = {
    sx: _styles.button_rules,
    variant  : 'contained',
    onClick  : onClick,
    children: 'Rules'
  }

  //#endregion

  //#region [EVENTS]

  function onClick( event ) {
    navigate( '/analytics/rules', { replace: true } );
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container} >
        <Button {...BUTTON_RULES} />
      </Box>
    )
  }

  //#endregion

  return display();
}
